import { z } from 'zod'

import { REQUIRED_FIELD_MESSAGE } from '@/constants'

export const treeEntityCreationSchema = z.object({
  description: z
    .string({ required_error: REQUIRED_FIELD_MESSAGE })
    .trim()
    .min(1, REQUIRED_FIELD_MESSAGE),
  parentId: z.string().trim().optional(),
  approveImmediately: z.boolean().optional(),
})

export type TreeEntityCreationType = z.infer<typeof treeEntityCreationSchema>
